
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWrench, faAddressCard, faFileLines, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../Context/AuthContext';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

const ClientHome = ()=>{
    const { logout } = useAuth();
    const navigate = useNavigate();

    async function handleLogout(){
        try{
            await logout();
            navigate("/client-login");
        }catch(error){
            toast.error(`Failed to log out: ${error.message}`);
        }
    }
    return(
        <div style={{display: 'flex', flexDirection: "column", alignItems:"center"}}>
            <div className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>CLIENT OPTIONS</div>
            <div style={{marginTop: 40, display: 'flex', flexDirection: "column", alignItems:"center"}}>
                <Button
                    className="btn-dark"
                    style={{backgroundColor:"#FFFFFF", border: "none", marginTop: 30, width: 256}}
                    onClick={()=>{
                        navigate("/client-service");
                    }}
                    >
                    <FontAwesomeIcon style={{color: "#2596be", fontSize: '4em', margin:10}} icon={faWrench} />
                    <p style={{color:"#000000", fontSize: '1em', margin:10}}>REQUEST FOR SERVICE</p>
                </Button>
                <Button
                    className="btn-dark"
                    style={{backgroundColor:"#FFFFFF", border: "none", marginTop: 30, width: 256}}
                    onClick={()=>{
                        navigate("/client-quote");
                    }}
                    >
                    <FontAwesomeIcon style={{color: "#2596be", fontSize: '4em', margin:10}} icon={faFileLines} />
                    <p style={{color:"#000000", fontSize: '1em', margin:10}}>REQUEST FOR QUOTE</p>
                </Button>
                <Button
                    className="btn-dark"
                    style={{backgroundColor:"#FFFFFF", border: "none", marginTop: 30, width: 256}}
                    onClick={()=>{
                        navigate("/client-profile");
                    }}
                    >
                    <FontAwesomeIcon style={{color: "#2596be", fontSize: '4em', margin:10}} icon={faAddressCard} />
                    <p style={{color:"#000000", fontSize: '1em', margin:10}}>PROFILE</p>
                </Button>
                <Button
                    className="btn-dark"
                    style={{backgroundColor:"#FFFFFF", border: "none", marginTop: 30, width: 256, marginBottom: 60}}
                    onClick={()=>{
                        handleLogout();
                    }}
                    >
                    <FontAwesomeIcon style={{color: "#2596be", fontSize: '4em', margin:10}} icon={faSignOutAlt} />
                    <p style={{color:"#000000", fontSize: '1em', margin:10}}>LOGOUT</p>
                </Button>
            </div>
        </div>
    )
};

export default ClientHome;